<template>
    <v-navigation-drawer
        v-model="active"
        right
        temporary
        fixed
        width="600"
    >
        <v-container class="pa-10" v-if="item">
            <v-row>
                <v-col>
                    <v-row class="align-center">
                        <v-btn icon class="black--text" @click="active = false">
                            <v-icon>mdi-chevron-left</v-icon>
                        </v-btn>

                        <h1 class="headline" style="white-space: nowrap">Eliminar Categoría</h1>
                    </v-row>
                </v-col>
            </v-row>

            <v-row>
                <v-col cols="12">
                    Esta seguro que desea eliminar la categoría {{ item.name }}?
                </v-col>
            </v-row>

            <v-row v-if="error">
                <v-col cols="12">
                    <span class="red--text">
                        {{ $t(error.message) }}
                    </span>
                </v-col>
            </v-row>
        </v-container>

        <template v-slot:append>
            <v-row class="ma-4">
                <v-spacer></v-spacer>

               <v-btn color="red"
                    @click="onSaveSelected"
                    :disabled="saving"
                    :loading="saving"
                    dark block
                >
                    Eliminar
                </v-btn>
            </v-row>
        </template>
    </v-navigation-drawer>
</template>

<script>
    export default {
        components: {},

        props: {
            item: Object,
            value: Boolean
        },

        data() {
            return {
                active: false,
                saving: false,
                error: null
            };
        },

        watch: {
            active(val) {
                this.error = null;

                this.$emit('input', val);
            },

            value(val) {
                this.active = val;
            }
        },

        methods: {
            async onSaveSelected() {
                this.saving = true;

                try {
                    await this.$store.dispatch('productCategory/delete', { category: this.item });
                    this.active = false;
                }
                catch (err) {
                    this.error = err;
                }
                finally {
                    this.saving = false;
                }
            }
        }
    };
</script>

<style lang="scss" scoped>

</style>
